import { forwardRef } from "react";
import { Link } from "react-router-dom";
import { Shield } from "lucide-react";
import { Button } from "@/components/ui/button";
import PhoneLink from "@/components/PhoneLink";

const FloatingCTA = forwardRef<HTMLDivElement>((_, ref) => {
  return (
    <div ref={ref} className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-surface/95 backdrop-blur-md border-t shadow-elevated safe-bottom">
      <div className="flex items-center gap-2 max-w-lg mx-auto p-3">
        <PhoneLink
          location="floating_cta"
          className="shrink-0 h-11 w-11 rounded-xl border border-input bg-surface flex items-center justify-center text-muted-foreground hover:text-foreground hover:border-copper"
          showIcon={true}
          showText={false}
          iconClassName="w-5 h-5"
        />
        <Button asChild className="flex-1 h-11 text-base font-semibold">
          <Link to="/quote">Get My Free Quote</Link>
        </Button>
        <div className="hidden xs:flex items-center gap-1 text-[10px] text-muted-foreground shrink-0">
          <Shield className="w-3 h-3 text-primary" />
          <span>AZ Licensed</span>
        </div>
      </div>
    </div>
  );
});

FloatingCTA.displayName = "FloatingCTA";

export default FloatingCTA;
